// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"d019bd059c9e2e9102e4","293":"cd2d3da525621f000268","518":"3300b16214ec460ba406","779":"948157632fa978a96660"}[chunkId] + ".js";
};